import { render, staticRenderFns } from "./ResultDigitDisplay.vue?vue&type=template&id=34dfc654&scoped=true&"
import script from "./ResultDigitDisplay.vue?vue&type=script&lang=js&"
export * from "./ResultDigitDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ResultDigitDisplay.vue?vue&type=style&index=0&id=34dfc654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dfc654",
  null
  
)

export default component.exports